import themeConfig from '../config/theme';

export function setTheme(theme) {
	const currentTheme = themeConfig[theme];

	Object.keys(currentTheme).forEach(key => {
		document.documentElement.style.setProperty(key, currentTheme[key]);
	});
}
